import React from "react";
import styled from "styled-components";
import { StoreSearchImport } from "./stores/organisms/StoreSearchImport";

const AddStoreContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const AddStoreHeader = styled.div`
  margin-bottom: 32px;
  text-align: center;
`;

const AddStore = styled.h1`
  color: #0058a3;
  margin-bottom: 16px;
`;

export const AddNewStorePage: React.FC = () => {
  return (
    <AddStoreContainer>
      <AddStoreHeader>
        <AddStore>IKEA Store Search & Import stores</AddStore>
        <p>
          Search for stores by ID from the global IKEA stores database and import them with your preferred primary
          language
        </p>
      </AddStoreHeader>
      <StoreSearchImport />
    </AddStoreContainer>
  );
};
